import{a as e}from"./chunk-RAAYCPUM.js";function d(...n){return e(o,n)}var o=(n,r)=>n.findIndex(r);export{d as a};
